import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
import { Util } from "../../../util/util";
export class MinimumOrderAmountQualifier {
    CalculationMethod = {
        IncludeAllWithDiscountedPrice: 0,
        IncludeAllWithOriginalPrice: 1,
        ExcludeItemsWithDiscountsOrLoyalty: 2,
        ExcludeDiscountedExceptLoyaltyWithOriginalPrice: 3,
        ExcludeDiscountedExceptLoyaltyWithDiscountedPrice: 4
    };
    _couponTypeExceptions = [
        30 /* CouponType.PERCENTAGE_OFF_ENTIRE_ORDER */,
    ];
    phase;
    constructor(phase) {
        this.phase = phase;
    }
    qualify(coupon, cart) {
        if (this._couponTypeExceptions.includes(coupon.couponTypeId) && this.phase === CouponApplyPhase.PostApply) {
            return { isValid: true, errorCode: null };
        }
        if (coupon.minimumOrderAmount === undefined || coupon.minimumOrderAmount === null || coupon.minimumOrderAmount <= 0) {
            return { isValid: true, errorCode: null };
        }
        this._calculateDiscountedQTYs(cart);
        let orderAmount = this._calculateMinimumOrderAmount(cart, coupon.calculationMethodID ?? undefined);
        if (orderAmount < coupon.minimumOrderAmount) {
            return { isValid: false, errorCode: CouponApplyErrorCode.MINIMUM_ORDER_AMOUNT_NOT_MET };
        }
        return { isValid: true, errorCode: null };
    }
    _calculateDiscountedQTYs(cart) {
        for (const item of cart.items) {
            let loyaltyDiscountsQty = 0;
            let nonLoyaltyDiscountsQty = 0;
            let loyaltyDiscountsAmount = 0;
            const iCoupons = cart.itemsCoupons.filter(x => x.itemKey == item.itemKey && x.halfIndex == item.halfIndex);
            for (const iCpn of iCoupons) {
                const appliedCoupon = cart.coupons.find(x => x.couponKey == iCpn.couponKey);
                if (appliedCoupon?.isReward) {
                    loyaltyDiscountsQty += 1;
                    loyaltyDiscountsAmount += Util.Float2(item.price - (appliedCoupon.amount / item.halfCount));
                }
                else {
                    nonLoyaltyDiscountsQty += 1;
                }
            }
            item.loyaltyDiscountsQTY = loyaltyDiscountsQty;
            item.nonLoyaltyDiscountsQTY = nonLoyaltyDiscountsQty;
            item.loyaltyDiscountsAmount = loyaltyDiscountsAmount;
        }
    }
    _calculateMinimumOrderAmount(cart, calcMethodId) {
        switch (calcMethodId) {
            case null:
            case undefined:
            case this.CalculationMethod.IncludeAllWithDiscountedPrice:
                return cart.subtotal - cart.discount;
            case this.CalculationMethod.IncludeAllWithOriginalPrice:
                return cart.subtotal;
            case this.CalculationMethod.ExcludeItemsWithDiscountsOrLoyalty: {
                let orderAmount = 0;
                for (const item of cart.items) {
                    orderAmount += this._calculateNonDiscountedItems(item);
                }
                return orderAmount;
            }
            case this.CalculationMethod.ExcludeDiscountedExceptLoyaltyWithOriginalPrice: {
                let orderAmount = 0;
                for (const item of cart.items) {
                    //handle any non discounted items
                    orderAmount += this._calculateNonDiscountedItems(item);
                    //handle loyalty with original price
                    if (item.loyaltyDiscountsQTY > 0 && item.nonLoyaltyDiscountsQTY === 0) {
                        orderAmount += Util.Float2(item.price);
                    }
                }
                return orderAmount;
            }
            case this.CalculationMethod.ExcludeDiscountedExceptLoyaltyWithDiscountedPrice: {
                let orderAmount = 0;
                for (const item of cart.items) {
                    //handle any non discounted items
                    orderAmount += this._calculateNonDiscountedItems(item);
                    //handle loyalty with original price
                    if (item.loyaltyDiscountsQTY > 0 && item.nonLoyaltyDiscountsQTY === 0) {
                        orderAmount += item.loyaltyDiscountsAmount;
                    }
                }
                return orderAmount;
            }
        }
        return 0;
    }
    _calculateNonDiscountedItems(item) {
        let orderAmount = 0;
        const nonDiscountedQTY = item.quantity - item.nonLoyaltyDiscountsQTY - item.loyaltyDiscountsQTY;
        if (nonDiscountedQTY > 0) {
            orderAmount += Util.Float2(item.price * nonDiscountedQTY);
        }
        return orderAmount;
    }
}
//# sourceMappingURL=minimum-order-amount.js.map